import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForCarriers from "@/pages/ForCarriers";
import About from "@/pages/About";
import ShipWithXD from "@/pages/ShipWithXD";
import FindLoads from "@/pages/FindLoads";
import LoadDetail from "@/pages/LoadDetail";
import Marketplace from "@/pages/Marketplace";
import Funding from "@/pages/Funding";
import Academy from "@/pages/Academy";
import Pricing from "@/pages/Pricing";
import Notifications from "@/pages/Notifications";
import Hotshot from "@/pages/Hotshot";

import Onboarding from "@/pages/carrier/Onboarding";
import Equipment from "@/pages/carrier/Equipment";
import Team from "@/pages/carrier/Team";
import CarrierDashboard from "@/pages/carrier/Dashboard";
import XDMoney from "@/pages/carrier/XDMoney";
import XDScore from "@/pages/carrier/XDScore";
import AIDispatcher from "@/pages/carrier/AIDispatcher";
import Documents from "@/pages/carrier/Documents";
import MyLoads from "@/pages/carrier/MyLoads";
import MyBids from "@/pages/carrier/MyBids";
import Profile from "@/pages/carrier/Profile";

import ShipperDashboard from "@/pages/shipper/Dashboard";
import AdminDashboard from "@/pages/admin/AdminDashboard";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/for-carriers" element={<ForCarriers />} />
            <Route path="/about" element={<About />} />
            <Route path="/ship" element={<ShipWithXD />} />
            <Route path="/find-loads" element={<FindLoads />} />
            <Route path="/find-loads/:id" element={<LoadDetail />} />
            <Route path="/hotshot" element={<Hotshot />} />
            <Route path="/marketplace" element={<Marketplace />} />
            <Route path="/funding" element={<Funding />} />
            <Route path="/academy" element={<Academy />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/notifications" element={<ProtectedRoute><Notifications /></ProtectedRoute>} />

            <Route path="/onboarding" element={<ProtectedRoute roles={["carrier"]}><Onboarding /></ProtectedRoute>} />
            <Route path="/dashboard" element={<ProtectedRoute roles={["carrier"]}><CarrierDashboard /></ProtectedRoute>} />
            <Route path="/dashboard/money" element={<ProtectedRoute roles={["carrier"]}><XDMoney /></ProtectedRoute>} />
            <Route path="/dashboard/score" element={<ProtectedRoute roles={["carrier"]}><XDScore /></ProtectedRoute>} />
            <Route path="/dashboard/ai-dispatcher" element={<ProtectedRoute roles={["carrier"]}><AIDispatcher /></ProtectedRoute>} />
            <Route path="/dashboard/equipment" element={<ProtectedRoute roles={["carrier"]}><Equipment /></ProtectedRoute>} />
            <Route path="/dashboard/team" element={<ProtectedRoute roles={["carrier"]}><Team /></ProtectedRoute>} />
            <Route path="/dashboard/documents" element={<ProtectedRoute roles={["carrier"]}><Documents /></ProtectedRoute>} />
            <Route path="/dashboard/my-loads" element={<ProtectedRoute roles={["carrier"]}><MyLoads /></ProtectedRoute>} />
            <Route path="/dashboard/bids" element={<ProtectedRoute roles={["carrier"]}><MyBids /></ProtectedRoute>} />
            <Route path="/dashboard/profile" element={<ProtectedRoute roles={["carrier"]}><Profile /></ProtectedRoute>} />

            <Route path="/shipper" element={<ProtectedRoute roles={["shipper"]}><ShipperDashboard /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute roles={["admin"]}><AdminDashboard /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" theme="dark" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
